"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MentionTargetType = exports.ConversationParticipantRole = exports.ConversationType = exports.ConversationStatus = exports.TRANSCRIPT_ONLY_MESSAGE_TYPES = exports.MessageType = void 0;
var MessageType;
(function (MessageType) {
    MessageType["AI_MESSAGE"] = "aiMessage";
    /** Transcript-only: an intermediate assistant round that produced tool calls.
     * Never rendered by the chat UI. */
    MessageType["ASSISTANT_TOOL_CALLS"] = "assistantToolCalls";
    MessageType["CHARACTER_PHOTOS_UPLOADED"] = "characterPhotosUploaded";
    MessageType["ERROR_MESSAGE"] = "errorMessage";
    MessageType["NEW_CONVERSATION"] = "newConversation";
    MessageType["NOTIFICATION"] = "notification";
    MessageType["PERFORMER_CONTRACT_DECLINED"] = "performerContractDeclined";
    MessageType["SUPPORT_MESSAGE"] = "supportMessage";
    MessageType["CANCEL"] = "cancel";
    MessageType["SYSTEM_MESSAGE"] = "systemMessage";
    /** Transcript-only: an MCP tool result (a `role:"tool"` message in the rebuilt transcript).
     * Never rendered by the chat UI. */
    MessageType["TOOL_MESSAGE"] = "toolMessage";
    /** Ephemeral typing-indicator ping — never persisted as a ChatMessage row. */
    MessageType["TYPING"] = "typing";
    MessageType["UPDATED_CONVERSATION"] = "updatedConversation";
    MessageType["USER_MESSAGE"] = "userMessage";
})(MessageType || (exports.MessageType = MessageType = {}));
/** Transcript-only message types: rows persisted for multi-turn bot memory that never
 * render as chat bubbles and never count as unread. Shared so the API's unread-count
 * whitelist and the web's render filter derive from one set and cannot drift.
 * (SYSTEM_MESSAGE renders in the UI but is deliberately excluded from unread counts —
 * that exclusion stays local to the count query, not shared here.) */
exports.TRANSCRIPT_ONLY_MESSAGE_TYPES = [
    MessageType.ASSISTANT_TOOL_CALLS,
    MessageType.TOOL_MESSAGE,
];
var ConversationStatus;
(function (ConversationStatus) {
    ConversationStatus["OPEN"] = "open";
    ConversationStatus["CLOSED"] = "closed";
})(ConversationStatus || (exports.ConversationStatus = ConversationStatus = {}));
var ConversationType;
(function (ConversationType) {
    ConversationType["SUPPORT"] = "support";
    ConversationType["TALENT_MANAGER"] = "talentManager";
    ConversationType["PROJECT"] = "project";
    ConversationType["BOT"] = "bot";
})(ConversationType || (exports.ConversationType = ConversationType = {}));
var ConversationParticipantRole;
(function (ConversationParticipantRole) {
    ConversationParticipantRole["AGENCY"] = "agency";
    ConversationParticipantRole["TALENT_MANAGER"] = "talentManager";
    ConversationParticipantRole["SUPPORT"] = "support";
    ConversationParticipantRole["ADMIN_OBSERVER"] = "adminObserver";
})(ConversationParticipantRole || (exports.ConversationParticipantRole = ConversationParticipantRole = {}));
var MentionTargetType;
(function (MentionTargetType) {
    MentionTargetType["USER"] = "user";
    MentionTargetType["BOT"] = "bot";
    MentionTargetType["SUPPORT"] = "support";
})(MentionTargetType || (exports.MentionTargetType = MentionTargetType = {}));
//# sourceMappingURL=chat-types.js.map